import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #fafafa;
  padding: 40px;
  width: 100%;

  .loader {
    max-width: 800px;

    .loader-inner {
      div {
        margin-left: auto;
        margin-right: auto;
        margin-top: 100px;
        border-color: #2a4169;
      }
    }
  }
`;

export const Title = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
`;

export const Form = styled.div`
  background: #ffffff;
  border: 1px solid #d5d9dd;
  border-radius: 8px;
  max-width: 960px;
  padding: 20px;
  margin-top: 12px;

  ${p => p.maxWidth && `
    max-width: ${p.maxWidth};
  `}

  ${p => p.height && `
    height: ${p.height};
  `}

  .loader {
    max-width: auto;

    .loader-inner {
      div {
        margin: 0;
      }
    }
  }
`;

export const FormTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);

  span {
    color: #ee6863;
    font-weight: 500;
    font-size: 16px;
  }
`;

export const FormColumns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 24px;
  gap: 40px;
`;

export const FormColumn = styled.div`
  flex: 1;

  input[type="text"] {
    display: block;
    width: 100%;
    margin: 4px 0 0;
    padding: 5px 12px;
    background: #ffffff;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    outline: none;

    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 27, 59, 0.94);

    &:read-only {
      color: rgba(0, 27, 59, 0.38);
      background: rgba(0, 27, 59, 0.04);
    }
  }
`;

export const FormLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`;

export const FormLabelLeft = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.94);
`;

export const FormLabelRight = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 27, 59, 0.38);
`;

export const Line = styled.div`
  width: 100%;
  max-width: 960px;
  height: 1px;
  background: #d5d9dd;
  margin-top: 20px;
`;

export const Description = styled.div`
  max-width: 800px;
  margin-top: 12px;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
`;

export const ButtonRow = styled.div`
  margin-top: 20px;
  text-align: right;
`;

export const Button = styled.button`
  display: inline-block;
  width: 160px;
  height: 40px;
  margin: 0;
  padding: 0;
  border-radius: 4px;
  border: 0;
  background: #5c91f5;
  cursor: pointer;
  outline: none;
  transition: background-color 0.5s ease-in-out;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #ffffff;

  &:hover {
    background-color: #85acf7;
  }
`;

export const InfoTooltip = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #5c91f5;

  width: 273px;
  height: 40px;
  background: rgba(0, 27, 59, 0.04);
  border-radius: 4px;
  margin-top: 40px;
`;

export const ModalVideoWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #3A507B;
  border-radius: 10px;

  &:before {
    display: block;
    content: '';
    align-items: center;
    background: #0006;
    display: flex;
    justify-content: center;
    opacity: 1;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    transition: opacity .3s ease;
    border-radius: 10px;
  }

  &.is-playing:before, &.is-playing button {
    opacity: 0;
  }
  &.is-playing:hover:before, &.is-playing:hover button {
    opacity: 1;
  }
  &:hover video {
    cursor: pointer;
  }
`;

export const PlayPauseButton = styled.button`
  align-items: center;
  background: none;
  background: #2a4169;
  border: none;
  border-radius: 50%;
  box-shadow: 0 4px 4px 0 #0000001a;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 2rem;
  height: 80px;
  justify-content: center;
  padding: 0;
  text-align: center;
  width: 80px;
  z-index: 2;
  position: absolute;
  transition: opacity .3s ease;
  opacity: 1;
`;

export const CloseModalVideoButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  color: #fff;
  padding: 0;
  line-height: normal;
`;


// WEBPACK FOOTER //
// ./src/components/goals-and-targets/styles.js